/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import axios from 'axios';
import { API_URL } from '../constants';
import type { PaymentRequestData } from '../types/ninox.types';
import type { AxiosReturn } from '../types/return.types';
import { getAPIToken } from '../utils';

const client = axios.create({
  baseURL: API_URL,
});

export default class PaymentService {
  static async createPaymentForPatient(paymentRequestData: PaymentRequestData): Promise<AxiosReturn> {
    try {
      const response = await client.post('/payment/create-for-patient', paymentRequestData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAPIToken()}`,
        },
      });
      return { error: false, message: 'Success', data: response.data };
    } catch (e: any) {
      const message = e?.response?.data?.message ?? e?.message ?? 'Request failed';
      return { error: true, message, data: null };
    }
  }
}
